import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

/** The two app screenshots the phone slot crossfades between, every 3s. */
const BOOKING_SHOTS = [
  { src: '/images/booking-session.png', key: 'session' },
  { src: '/images/booking-calendar.png', key: 'calendar' },
];

const ROTATE_MS = 3000;

/** Booking split — source: mockup L343–387; phone is a rotating pair of real app screenshots. */
const BookingSplit = (): React.JSX.Element => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setActive((current) => (current + 1) % BOOKING_SHOTS.length),
      ROTATE_MS,
    );
    return () => clearInterval(timer);
  }, []);

  return (
  <section className="oq-booking">
    <div className="oq-container oq-booking__inner">
      <div className="oq-booking__row">
        <div className="oq-booking__copy">
          <div className="oq-booking__kicker oq-bebas">SPORTS BOOKING APP</div>
          <h2 className="oq-booking__title oq-bebas">Booking a session takes two taps</h2>
          <p className="oq-booking__subtitle">
            Members browse by group, tap a session, and they&apos;re in. Paid sessions check out
            with a saved card. Make an update and members see it immediately — with refunds for
            cancellations when you enable them.
          </p>
          <div className="oq-booking__bullets">
            <div className="oq-booking__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>List &amp; calendar views</b> — members see the week at a glance or scan a
                month.
              </span>
            </div>
            <div className="oq-booking__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Recurring sessions</b> — run weekly, fortnightly or as one-offs, so you
                never recreate the same event each week.
              </span>
            </div>
            <div className="oq-booking__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Enable refunds</b> — give members flexibility on cancellations, without the
                club losing a penny.
              </span>
            </div>
          </div>
          <Link to="/help-centre" className="oq-booking__link">
            Read the guide <i className="mdi mdi-arrow-right" aria-hidden="true" />
          </Link>
        </div>

        <div className="oq-booking__phone" aria-hidden="true">
          {/* Real app screenshots, used exactly as supplied (own device frame,
              transparent background), crossfading on a timer — no user controls. */}
          <div className="oq-booking__rotator">
            {BOOKING_SHOTS.map((shot, index) => (
              <img
                key={shot.key}
                src={shot.src}
                alt=""
                className={`oq-booking__shot${index === active ? ' oq-booking__shot--active' : ''}`}
                loading="lazy"
                width="1080"
                height="1920"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default BookingSplit;
